import template from "./timezone-selector.html";

const TimezoneSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class TimezoneController {
    /* @ngInject */
    constructor($scope, moment) {
      this.$scope = $scope;
      this.moment = moment;
    }

    $onInit() {
      this.timezones = this.moment.tz.names();
      this.timezone = this.defaultValue;
      this.$scope.$watch(
        () => this.timezone,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) this.onChange({ oldTimezone: oldVal, newTimezone: this.timezone });
        },
      );
    }

    $onChanges(changesObj) {
      if (changesObj.defaultValue && !changesObj.defaultValue.isFirstChange()) this.timezone = this.defaultValue;
    }
  },
};

export default TimezoneSelectorComponent;
